/**
 * get the file type out of a file name without the .
 * @param fileName
 */
export function filetype(fileName: string) {
  return fileName?.substring(fileName.lastIndexOf(".") + 1);
}
export function fileName(fileName: string) {
  return fileName.replace("." + filetype(fileName), "");
}
